// French translations
import { merge } from 'lodash'

import baseTranslations from './store/fr.js'

const sources = [baseTranslations]

export default merge({}, ...sources)
